export const AUTH_TOKEN_KEY = 'EIQ_ASSESS_ADMIN_AUTH_TOKEN_KEY';
export const AUTH_TOKEN_CHANGED_EVENT = 'authTokenChanged';

export const UserRole = {
  Admin: 'Admin',
  Auditor: 'Auditor',
  CapManager: 'CAP Manager',
  CapManagerRead: 'CAP',
  CapSupportStaff: 'CAP Support Staff',
  FactoryUser: 'Factory user',
  MasterDataManager: 'MasterData',
  ReportReviewer: 'ReportReview',
  VendorUser: 'Vendor user',
};
